import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import { useEffect, useMemo } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { LogTipoTabela } from "../../../../../../common/utils/log_tabela_tipo";
import { FormSwitchInput } from "../../../../../../common/components/masked_inputs/react_forms/form_switch_input";
import { TermoEpi } from "../../../../domain/models/termo_epi";
import {
  defaultTermoEpiForm,
  TermoEpiForm,
  TermoEpiSchema,
} from "../../../schemas/TermoEpi/termo_epi";
import { DefaultFormRadioGroupInput } from "../../../../../../common/components/default_form_radio_group_input";

type props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectedTermoEpi: TermoEpi | null;
  handleOpenChangeHistory: (
    idTabela: number | null,
    tipoTabela: LogTipoTabela | null,
  ) => void;
  onClose: () => void;
  onSubmit: (form: TermoEpiForm) => void;
};

export const CadastroTermoEpiModal = ({
  open,
  saving,
  loading,
  selectedTermoEpi,
  handleOpenChangeHistory,
  onClose,
  onSubmit,
}: props) => {
  
  const hookFormCadastro = useForm<TermoEpiForm>({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    defaultValues: defaultTermoEpiForm,
    resolver: zodResolver(TermoEpiSchema),
  });
  const ativoOptions = useMemo(() => {
    return [
      { id: 1, label: "Sim" },
      { id: 0, label: "Não" },
    ];
  }, []);

  useEffect(() => {
    if (selectedTermoEpi) {
      hookFormCadastro.setValue("idTermoEpi", selectedTermoEpi.idTermoEPI);
      hookFormCadastro.setValue("codigo", selectedTermoEpi.codigo ?? "");
      hookFormCadastro.setValue("nome", selectedTermoEpi.nome ?? "");
      hookFormCadastro.setValue("descricao", selectedTermoEpi.descricao ?? "");
      hookFormCadastro.setValue("ativo", selectedTermoEpi.ativo === true ? 1 : 0);
    } else {
      hookFormCadastro.reset(defaultTermoEpiForm);
    }
  }, [selectedTermoEpi, hookFormCadastro]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      width={"70rem"}
      title="Cadastro Termo"
      onClose={onClose}
      // leftButtonSlot={
      //   selectedTermoEpi && (
      //     <PrimaryButton
      //       buttonColor="yellow"
      //       onClick={() =>
      //         handleOpenChangeHistory(
      //           selectedTermoEpi?.idTermoEPI ?? null,
      //           LogTipoTabela.TERMO,
      //         )
      //       }
      //     >
      //       <span className="text-xs">Historico de alterações</span>
      //     </PrimaryButton>
      //   )
      // }
      onSubmit={hookFormCadastro.handleSubmit(onSubmit)}
    >
      <FormContainer title={"Informações"} arrangement="fullRow">
        <>
          <div>
            <DefaultFormRadioGroupInput
              name="ativo"
              label="Ativo"
              options={ativoOptions}
              reactHookForm={hookFormCadastro}
            />
          </div>
          <div className="w-1/2">
            <DefaultFormInput
              name="codigo"
              label="Código do Termo"
              readOnly={false}
              required={true}
              reactHookForm={hookFormCadastro}
            />
          </div>

          <DefaultFormInput
            name="nome"
            label="Nome do Termo"
            readOnly={false}
            required={true}
            reactHookForm={hookFormCadastro}
          />

          <DefaultFormInput
            name={"descricao"}
            label="Descrição do Termo"
            readOnly={saving}
            required={false}
            multiline={true}
            rows={12}
            minRows={5}
            maxRows={14}
            reactHookForm={hookFormCadastro}
          />
        </>
      </FormContainer>
    </BaseFormControlledModal>
  );
};
